import { useCallback } from 'react';

export const useCopyToClipboard = (text: string) => {
	const callback = useCallback(() => {
		navigator.clipboard.writeText(text);
	}, [text]);
	return callback;
};
